export default __webpack_public_path__ + "static/6 Major Mistakes When Choosing an EP Attorney-baac8c83471e9368a1713dde7a6f0dba.pdf";